module.exports = new __parcel__URL__("logo_qcd.7ac90334.png").toString();